import React, { Component } from "react";
import { connect } from "react-redux";
import { getSearchParams, getRevDate, fetchGet, getFormattedDayDate } from "../../common/common";
import {
  getSearchResults,
  updateHeaderText,
  updateSeatChartDet,
  updateServiceTypeFilter,
  updateFareRange,
  updateLinkedCityData,
} from "../../actions/search-actions";
import store from "../../store";
import Modify from "../modify/modify";
import LinkModify from "../modify/linkModify"
import Listing from "../listing/listing";
import HeaderNew from "../header/HeaderNew";
import Footer from "../header/footer";
import { apiUrl } from "../common/constants";
import SortDetails from "../sort/sortDetails";
import Filter from "../filter/filter";
import LinkTripsModel from "../common/LinkTripsModel";
import { CONNECT_TRIP, NEXT_DAY_TRIPS, ONWARD_TRIP, PREV_DAY_TRIPS, RETURN_TRIP, START_TRIP, t } from "../../translations/Search";
import { CONNECT_BUS_OPTION,tCommon } from "../../translations/Common";
import Alert from "../common/alert";

let srchPrm = "";
let msurl = window.msurl;

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      prevLink: "",
      nextLink: "",
      holdFlag: '',
      showLinkedTrips:false,
    };
  }

  componentWillMount() {
    srchPrm = getSearchParams();
  }

  setpickupdropoff = (rsid) => {
    if (!this.props.search.stChrtOthrDtls[rsid]) {
      const url = window.url + apiUrl.routeInfo + "?routeID=" + rsid;
      fetchGet(url)
        .then((data) => {
          store.dispatch(updateSeatChartDet(rsid, data));
        })
        .catch((err) => console.log(err));
    }
  };

  setBusTypeFilter = (data) => {
    const busTypeFilter = data && data.length > 0 && [...new Set(data.map(el => el.ServiceType))];
    store.dispatch(updateServiceTypeFilter(busTypeFilter));
  }

  componentDidMount() {
    const that = this;
    that.setState({ showLoader: true });
    let url = ''
    if (srchPrm && srchPrm.linkfromstoptocity) {
      url =
        window.url +
        apiUrl.search +
        "?fromCityID=" +
        srchPrm.fromCity.split("|")[0] +
        "&toCityID=" +
        srchPrm.toCity.split("|")[0] +
        "&fromCityName=" +
        srchPrm.fromCity.split("|")[1] +
        "&toCityName=" +
        srchPrm.toCity.split("|")[1] +
        "&journeyDate=" +
        getRevDate(srchPrm.departDate) +
        "&mode=" +
        srchPrm.mode +
        "&linktrip=" + srchPrm.linkfromstoptocity;
    } else {
      url =
        window.url +
        apiUrl.search +
        "?fromCityID=" +
        srchPrm.fromCity.split("|")[0] +
        "&toCityID=" +
        srchPrm.toCity.split("|")[0] +
        "&fromCityName=" +
        srchPrm.fromCity.split("|")[1] +
        "&toCityName=" +
        srchPrm.toCity.split("|")[1] +
        "&journeyDate=" +
        getRevDate(srchPrm.departDate) +
        "&mode=" +
        srchPrm.mode;
    }

    if (srchPrm && srchPrm.IsSingleLady == 1) {
      url += '&IsSingleLady=1';
    }

    fetchGet(url)
      .then(function (data) {

        /* data = data.sort((a, b) => {
          return a.DepartureTime > b.DepartureTime
            ? 1
            : b.DepartureTime > a.DepartureTime
              ? -1
              : 0;
        }); */

        store.dispatch(getSearchResults(data));
        // data && data.length > 0 && data.map(el => that.setpickupdropoff(el.RouteScheduleId))
        const busfare = [];
        if (data.length > 0) {
          data.map((el) => {
            if (busfare.indexOf(el.DiscFare) === -1) {
              busfare.push(el.DiscFare);
            }
          });
        }
        const maxFare = busfare.length > 0 ? Math.max(...busfare) : 0;
        const minFare = busfare.length > 0 ? Math.min(...busfare) : 0;
        store.dispatch(updateFareRange({ min: Math.min(minFare), max: Math.max(maxFare) }));
        that.setBusTypeFilter(data);
        that.setState({ showLoader: false });
      })
      .catch(function (error) {
        store.dispatch(getSearchResults(false));
        that.setState({ showLoader: false });
        console.log(error);
      });

    setTimeout(() => {
      if (that.props.search) {
        let trip = that.props.search.searchParams.mode;
        if (that.props.search.searchParams.mode === "roundtrip") {
          trip = "Return trip";
          if (!that.props.search.searchParams.token) {
            trip = "Onward trip";
          }
        } else {
          trip = "Onward trip";
        }
        store.dispatch(
          updateHeaderText({
            text1:
              srchPrm.fromCity.split("|")[1] +
              " - " +
              srchPrm.toCity.split("|")[1],
            text2: trip,
          })
        );
      }
      this.parseNextPrevLinks();
    }, 500);

    const urlParams = new URLSearchParams(window.location.search);
    const holdFlag = urlParams.get('apiName');
    this.setState({ holdFlag: holdFlag });
  }

  parseNextPrevLinks = () => {
    const departDate = new Date(
      getRevDate(this.props.search.searchParams.departDate)
    );
    const currDate = new Date(new Date(window.today).toDateString());
    let tomorrow = new Date(departDate);
    let yesterday = new Date(departDate);
    let dayBeforeTomorrow = new Date(departDate);
    let maxDate = new Date(window.today);
    tomorrow.setDate(departDate.getDate() + 1);
    yesterday.setDate(departDate.getDate() - 1);
    maxDate.setDate(new Date(maxDate.getDate() + window.daysForCalendar));
    const prevLink = currDate < yesterday ? this.getSearchUrl(yesterday) : false;
    // console.log(dayBeforeTomorrow.getDate());
    // console.log(maxDate.getDate());
    const nextLink = (dayBeforeTomorrow.getDate() === maxDate.getDate() && dayBeforeTomorrow.getMonth() === maxDate.getMonth()) ? false : this.getSearchUrl(tomorrow);
    this.setState({ prevLink, nextLink });
  }

  getSearchUrl = (val) => {
    const { searchParams } = this.props.search;
    if (searchParams.linkfromstoptocity) {
      const dt = "departDate=" + this.getFormattedDateForURL(val);
      const dt1 = "&returnDate=" + this.getFormattedDateForURL(val);
      let srchUrl = "/search";
      const srchParams = window.location.search;
      let tempDt =
        srchParams.indexOf("departDate=") >= 0
          ? srchParams.split("departDate=")
          : false;
      // tempDt[1] =
      //   tempDt[1].indexOf("&") >= 0
      //     ? tempDt[1].substr(tempDt[1].indexOf("&"))
      //     : "";
      let tempDt1 = tempDt[1] && tempDt[1].indexOf("returnDate=") >= 0 ? tempDt[1].split("returnDate=") : false;
      tempDt1[1] = tempDt1[1].indexOf("&") >= 0
        ? tempDt1[1].substr(tempDt1[1].indexOf("&"))
        : "";
      // console.log("tempDt[2]", tempDt[0] + dt + dt1 + tempDt1[1]);
      srchUrl += tempDt[0] + dt + dt1 + tempDt1[1];
      return srchUrl;
    } else {
      const dt = "departDate=" + this.getFormattedDateForURL(val);
      let srchUrl = "/search/";
      const srchParams = window.location.search;
      let tempDt =
        srchParams.indexOf("departDate=") >= 0
          ? srchParams.split("departDate=")
          : false;
      tempDt[1] =
        tempDt[1].indexOf("&") >= 0
          ? tempDt[1].substr(tempDt[1].indexOf("&"))
          : "";
      srchUrl += tempDt[0] + dt + tempDt[1];
      return srchUrl;
    }
  };

  getFormattedDateForURL = (dateString) => {
    //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
    const d = dateString;
    let day = d.getDate(),
      month = d.getMonth() + 1,
      year = d.getFullYear();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return day + "-" + month + "-" + year;
  };

  showbushead = (buses) => {
    return (
      <h3 style={{ color: '#5f5f6d', fontWeight: '600', margin: '30px 6% 15px 6%', fontSize: '24px' }}>
        {buses && buses > 1 ? buses + "  Buses" : buses + "  Bus"} found for {" "}
        <span style={{ color: '#cb0e0e', fontWeight: 700 }}>
          {srchPrm.fromCity.split("|")[1] + " - " + srchPrm.toCity.split("|")[1]}  on {srchPrm.departDate}
        </span>
      </h3>
    )
  }

  ShowcardItem = (buses) => {
    if (buses > 0) {
      return (
        <div className="card--head">
          <div>Departure</div>
          <div>Duration</div>
          <div>Arrival</div>
          <div className="coach">Coach</div>
          <div>Fare</div>
          <div>Seats</div>
          <div>&nbsp;</div>
        </div>
      )
    }
    else {
      return null;
    }
  }

  modifyTripDate = (date) => {
    let dt = `${date.split('-')[2]}-${date.split('-')[1]}-${date.split('-')[0]}:00:00:00`;
    return dt;
  }


  showTripsLabel = () => {
    const { searchParams } = this.props.search;
    const { linkfromstoptocity } = searchParams;
    const { token } = searchParams;
    if (linkfromstoptocity) {
      let startJourneyDate = JSON.parse(sessionStorage.getItem("startTripJourneyDate")) || searchParams.departDate;
      if (token) {
        startJourneyDate = startJourneyDate;
      } else {
        startJourneyDate = searchParams.departDate;
      }
      return (
        <div className="trip--label--wrap flex">
          <div className={`trip--label ${token ? 'in--active' : 'active'}`}>
            <div>{`${t(START_TRIP)}: ${searchParams && linkfromstoptocity.split('|')[1]} - ${searchParams && linkfromstoptocity.split('|')[3]}, ${startJourneyDate && getFormattedDayDate(this.modifyTripDate(startJourneyDate))}`}</div>
          </div>
          {<div className={`trip--label ${this.props.search.searchParams.mode === "roundtrip" && token ? 'active' : 'in--active'}`}>
            <div>{`${t(CONNECT_TRIP)}: ${linkfromstoptocity.split('|')[3]} - ${linkfromstoptocity.split('|')[5]}, ${searchParams.returnDate && getFormattedDayDate(this.modifyTripDate(searchParams.returnDate))}`}</div>
          </div>}
        </div>
      )
    } else {
      return (
        <div className="trip--label--wrap flex">
          <div className={`trip--label ${token ? 'in--active' : 'active'}`}>
            <div>{`${t(ONWARD_TRIP)}: ${token ? (searchParams && searchParams.toCity.split('|')[1]) : (searchParams && searchParams.fromCity.split('|')[1])} - ${token ? (searchParams && searchParams.fromCity.split('|')[1]) : (searchParams && searchParams.toCity.split('|')[1])}, ${searchParams.departDate && getFormattedDayDate(this.modifyTripDate(token ? searchParams.returnDate : searchParams.departDate))}`}</div>
          </div>
          {this.props.search.searchParams.mode === "roundtrip" && <div className={`trip--label ${this.props.search.searchParams.mode === "roundtrip" && token ? 'active' : 'in--active'}`}>
            <div>{`${t(RETURN_TRIP)}: ${token ? (searchParams && searchParams.fromCity.split('|')[1]) : (searchParams && searchParams.toCity.split('|')[1])} - ${token ? (searchParams && searchParams.toCity.split('|')[1]) : (searchParams && searchParams.fromCity.split('|')[1])}, ${searchParams.returnDate && getFormattedDayDate(this.modifyTripDate(token ? searchParams.departDate : searchParams.returnDate))}`}</div>
          </div>}
          {/* Prev-Next Trip Buttons Start */}
          <div className="trip--prev--next-wrap">
            <span
              className={this.state.prevLink && !this.props.search.searchParams.token ? "" : "crsrnotallowed"}
              style={{
                opacity: this.state.prevLink && !this.props.search.searchParams.token ? "1" : "0.4",
              }}
            >
              <a className={`sfbutton flex-vc ${this.state.prevLink && !this.props.search.searchParams.token ? "" : "disabled"}`} href={this.state.prevLink ? this.state.prevLink : ""}>
                <span className="arrowplain left"></span>
                <span>{t(PREV_DAY_TRIPS)}</span>
              </a>
            </span>
            <a className={`sfbutton flex-vc ${this.state.nextLink ? "" : "disabled"}`} href={this.state.nextLink ? this.state.nextLink : ""}>
              <span className={this.state.nextLink ? "" : "crsrnotallowed"}
                style={{ opacity: this.state.nextLink ? "1" : "0.4", }}>{t(NEXT_DAY_TRIPS)}</span>
              <span className="arrowplain right"></span>
            </a>
          </div>
          {/* Prev-Next Trip Buttons End */}
        </div>
      )
    }
  }

  getConnectBusOptions = () => {

    this.setState({showLinkedTrips:true});

    if(srchPrm && this.props.search.linkedCityData && this.props.search.linkedCityData.length == 0){

      const fromCityId = srchPrm.fromCity.split("|")[0];
      const toCityId = srchPrm.toCity.split("|")[0];
      const jDate  = getRevDate(srchPrm.departDate);

      const url = window.url + apiUrl.getLinkCity + "?fromCityId=" + fromCityId + "&toCityId=" + toCityId + "&journeyDate="+jDate;

      fetchGet(url).then(function (data) {
          //console.log("getLinkCity", data);
          if (data.IsSuccess) {
              const linkpairs = data.data;
              store.dispatch(updateLinkedCityData(linkpairs));
          }
          else {
              store.dispatch(updateLinkedCityData([]));
          }
      }).catch(function (error) {
          console.log(error);
          store.dispatch(updateLinkedCityData([]));
      });
    }
  }

  closeLinkTrips = () => {
    this.setState({showLinkedTrips:false});
  }

  render() {
    
    let that = this;

    const { searchParams, serviceTypeFilterList,buses } = this.props.search;
    const { linkfromstoptocity,mode } = searchParams;

    return (
      <div>
        <HeaderNew />
        {that.state.showLoader || that.props.search.loader ? (
          <div className="show-load">
            <div className="loading">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <div className="result-container">
            {linkfromstoptocity ? <LinkModify /> : <Modify />}
            {!that.state.showLoader && this.showTripsLabel()}
            {<SortDetails />}
            <div className="filter--and--card--wrap">
              <Filter />
              <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                <Listing handelConnectBusOption = {() => this.getConnectBusOptions()}/>
                {buses && mode!='roundtrip' && !linkfromstoptocity &&  
                  <div className="connect-bus-button-wrap">
                    <div className="btnConnectBus" onClick={() => this.getConnectBusOptions()}>{tCommon(CONNECT_BUS_OPTION)}</div>
                  </div>
                }
                {this.state.showLinkedTrips && <LinkTripsModel linkedCityData = {this.props.search.linkedCityData} searchParams={searchParams} close={() => this.closeLinkTrips(false)}/>}
              </div>
            </div>
          </div>
        )}

        {
          this.state.holdFlag === 'crs' && <Alert
            close={() => this.setState({ holdFlag: '' })}
            msg={'The seat you are trying to book is unavailable'}
          />
        }
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Search);
